export default "__VITE_ASSET__Dyh_LSYP__"